import * as React from 'react';
import { ClubMetadata, CmsContent } from '.';
import { CmsProvider } from './cms-provider';
import MetadataProvider from './metadata-provider';
import {
  MOST_RECENTLY_VIEW_CLUB_ID,
  MOST_RECENTLY_VIEW_SEARCH_CLUB_ID,
  setRecentlyViewedClubIdForKey,
} from 'src/components/layout/redesign/header-shared/promo-helper';
import { useContext, useEffect } from 'react';
import { SiteContext } from 'src/context/site-context';

export const ClubContentProvider = ({
  clubId,
  children,
}: {
  clubId?: string;
  children: React.ReactNode;
}) => {
  const { untranslatedPath } = useContext(SiteContext);
  const isClubPagePath = !!untranslatedPath && /^\/clubs\/(?!$)/.test(untranslatedPath);

  useEffect(() => {
    if (!(clubId && isClubPagePath)) return;

    setRecentlyViewedClubIdForKey(MOST_RECENTLY_VIEW_CLUB_ID, clubId);
    setRecentlyViewedClubIdForKey(MOST_RECENTLY_VIEW_SEARCH_CLUB_ID, clubId);
  }, [clubId]);

  return (
    <MetadataProvider clubId={clubId!}>
      {(clubMetadata) => (
        <CmsProvider clubId={clubId!}>
          {(cmsContent) => (
            <ClubMetadata.Provider value={clubMetadata}>
              <CmsContent.Provider value={cmsContent}>{children}</CmsContent.Provider>
            </ClubMetadata.Provider>
          )}
        </CmsProvider>
      )}
    </MetadataProvider>
  );
};

export default ClubContentProvider;
